import { getUserFullName } from '../services/UserService';

/**
 * Resolves a map of userId -> display name for the given ids (deduped).
 */
export const resolveUserDisplayNames = async (userIds) => {
  const unique = [...new Set((userIds ?? []).filter(Boolean))];
  if (unique.length === 0) return {};

  const entries = await Promise.all(
    unique.map(async (userId) => {
      try {
        const fullName = await getUserFullName(userId);
        return [userId, fullName];
      } catch {
        return [userId, null];
      }
    })
  );
  return Object.fromEntries(entries);
};

export const displayNameForUser = (namesById, userId) =>
  userId ? (namesById[userId] ?? null) : null;
